import '../../Styles/App.css';
import '../../Styles/Admin.css';
import { useCallback, useEffect, useState } from 'react';
import { MdArrowUpward, MdArrowDownward, MdDelete, MdAdd, MdWarning } from 'react-icons/md';
import { BiSolidPlaylist } from 'react-icons/bi';
import izenuAPI from '../../services/izenuAPI';
import WeeklyAutoPanel from './components/WeeklyAutoPanel';

function Cover({ url, size = 56 }) {
    const [err, setErr] = useState(false);
    if (!url || err) {
        return (
            <div style={{
                width: size, height: size, borderRadius: 8, flexShrink: 0,
                backgroundColor: '#eee', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
            }}>
                <BiSolidPlaylist size={size * 0.4} color="#999" />
            </div>
        );
    }
    return <img src={url} alt="" onError={() => setErr(true)}
        style={{ width: size, height: size, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />;
}

export default function WeeklyPlaylists() {
    const [entries, setEntries] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [dirty, setDirty] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [addSearch, setAddSearch] = useState('');

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const { data: r } = await izenuAPI.get('/admin/playlists/weekly.php');
            if (r.response) {
                setEntries(r.data);
                setDirty(false);
            }
        } catch (err) {
            alert('Erro ao carregar: ' + (err?.response?.data?.message || err.message));
        }
        setLoading(false);
    }, []);

    // Only verified public playlists can appear on the home page, so those are
    // the only ones offered as candidates.
    const loadCandidates = useCallback(async (q) => {
        try {
            const { data: r } = await izenuAPI.get('/admin/playlists/list.php', {
                params: { bucket: 'verified', q: q || '', min_tracks: 1, limit: 50 },
            });
            if (r.response) setCandidates(r.data);
        } catch (err) {
            console.log(err);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const move = (index, dir) => {
        const next = index + dir;
        if (next < 0 || next >= entries.length) return;
        const list = [...entries];
        [list[index], list[next]] = [list[next], list[index]];
        setEntries(list);
        setDirty(true);
    };

    const remove = (index) => {
        setEntries(entries.filter((_, i) => i !== index));
        setDirty(true);
    };

    const patch = (index, field, value) => {
        const list = [...entries];
        list[index] = { ...list[index], [field]: value };
        setEntries(list);
        setDirty(true);
    };

    const add = (playlist) => {
        if (entries.some(e => e.playlist_id === playlist.id)) {
            alert('Essa playlist já está na lista.');
            return;
        }
        setEntries([...entries, {
            id: null,
            playlist_id: playlist.id,
            title: playlist.title,
            author: playlist.author,
            image_url: playlist.image_url,
            status: playlist.status,
            verified: playlist.verified,
            track_count: playlist.track_count,
            eligible: playlist.verified === 1 && playlist.status === 'public' && playlist.track_count >= 1,
            label: '',
            subtitle: '',
        }]);
        setDirty(true);
        setShowAdd(false);
        setAddSearch('');
    };

    const save = async () => {
        setSaving(true);
        try {
            const { data: r } = await izenuAPI.post('/admin/playlists/saveWeekly.php', {
                entries: entries.map(e => ({
                    playlist_id: e.playlist_id,
                    label: e.label || '',
                    subtitle: e.subtitle || '',
                })),
            });
            if (r.response) {
                setEntries(r.data);
                setDirty(false);
            }
        } catch (err) {
            alert('Erro ao guardar: ' + (err?.response?.data?.message || err.message));
        }
        setSaving(false);
    };

    const inputStyle = {
        padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc',
        backgroundColor: '#fff', color: '#333', fontSize: 13, width: '100%',
    };
    const iconBtn = (disabled) => ({
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 30, height: 30, borderRadius: 6,
        border: '1px solid #e0e0e0', backgroundColor: '#fff',
        cursor: disabled ? 'default' : 'pointer',
        color: disabled ? '#ccc' : '#555',
    });

    return (
        <div style={{ padding: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8, flexWrap: 'wrap' }}>
                <h2 style={{ margin: 0, fontSize: 22, color: '#222' }}>Playlists da Semana</h2>
                <span style={{ fontSize: 13, color: '#888' }}>
                    {entries.length} na secção da home
                </span>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                    <button
                        onClick={() => { setShowAdd(!showAdd); if (!showAdd) loadCandidates(''); }}
                        style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            backgroundColor: '#fff', color: '#1976d2', border: '1px solid #1976d2',
                            padding: '8px 16px', borderRadius: 8, fontSize: 14, cursor: 'pointer', fontWeight: 600,
                        }}
                    ><MdAdd size={18} /> Adicionar playlist</button>
                    <button
                        onClick={save}
                        disabled={!dirty || saving}
                        style={{
                            backgroundColor: dirty ? '#4CAF50' : '#e0e0e0',
                            color: dirty ? '#fff' : '#999',
                            border: 'none', padding: '8px 20px', borderRadius: 8,
                            fontSize: 14, cursor: dirty && !saving ? 'pointer' : 'default', fontWeight: 600,
                        }}
                    >{saving ? 'A guardar…' : 'Guardar'}</button>
                </div>
            </div>

            <p style={{ margin: '4px 0 20px', maxWidth: 720, fontSize: 14, lineHeight: 1.5, color: '#555', textAlign: 'left' }}>
                Escolhe as playlists que aparecem na secção «Playlists da Semana», na home da app e do site, logo a
                seguir às rádios. A ordem desta lista é a ordem na home. Só entram playlists <strong>verificadas,
                públicas e com faixas</strong>; as outras ficam assinaladas e são ignoradas. Nada muda na home até
                carregares em Guardar.
            </p>

            <WeeklyAutoPanel onChanged={() => { if (!dirty) load(); }} />

            {showAdd && (
                <div style={{
                    padding: 16, marginBottom: 20, backgroundColor: '#fafafa',
                    borderRadius: 12, border: '1px solid #e0e0e0',
                }}>
                    <input
                        type="text"
                        autoFocus
                        value={addSearch}
                        placeholder="Pesquisar playlists verificadas…"
                        onChange={(e) => { setAddSearch(e.target.value); loadCandidates(e.target.value); }}
                        style={{ ...inputStyle, marginBottom: 12 }}
                    />
                    <div style={{ maxHeight: 280, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {candidates.length === 0 && (
                            <span style={{ fontSize: 13, color: '#888' }}>
                                Nenhuma playlist verificada encontrada. Verifica-a primeiro em "Verificar Playlists".
                            </span>
                        )}
                        {candidates.map(c => (
                            <div key={c.id} style={{
                                display: 'flex', alignItems: 'center', gap: 12,
                                padding: 8, backgroundColor: '#fff', borderRadius: 8,
                                border: '1px solid #e0e0e0',
                            }}>
                                <Cover url={c.image_url} size={40} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#222' }}>{c.title}</div>
                                    <div style={{ fontSize: 12, color: '#888' }}>
                                        {c.author} · {c.track_count} faixas
                                        {c.status === 'private' && ' · privada'}
                                    </div>
                                </div>
                                <button
                                    onClick={() => add(c)}
                                    style={{
                                        backgroundColor: '#1976d2', color: '#fff', border: 'none',
                                        padding: '6px 14px', borderRadius: 6, fontSize: 13,
                                        cursor: 'pointer', fontWeight: 600,
                                    }}
                                >Adicionar</button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {loading && <p style={{ color: '#888' }}>A carregar…</p>}
            {!loading && entries.length === 0 && (
                <p style={{ color: '#888' }}>A secção está vazia — não aparece na home.</p>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {entries.map((e, i) => (
                    <div key={e.playlist_id} style={{
                        backgroundColor: '#fff', borderRadius: 12, padding: 14,
                        border: `1px solid ${e.eligible ? '#e0e0e0' : '#ffcc80'}`,
                        display: 'flex', gap: 14, alignItems: 'center',
                    }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <button onClick={() => move(i, -1)} disabled={i === 0} style={iconBtn(i === 0)}>
                                <MdArrowUpward size={16} />
                            </button>
                            <button onClick={() => move(i, 1)} disabled={i === entries.length - 1} style={iconBtn(i === entries.length - 1)}>
                                <MdArrowDownward size={16} />
                            </button>
                        </div>

                        <span style={{ fontSize: 13, color: '#999', width: 18, textAlign: 'center' }}>{i + 1}</span>

                        <Cover url={e.image_url} />

                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 15, fontWeight: 600, color: '#222' }}>{e.title}</div>
                            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                                {e.author} · {e.track_count} faixas · id {e.playlist_id}
                            </div>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <input
                                    type="text"
                                    value={e.label || ''}
                                    placeholder="Etiqueta (ex: Lançamentos)"
                                    onChange={(ev) => patch(i, 'label', ev.target.value)}
                                    style={inputStyle}
                                />
                                <input
                                    type="text"
                                    value={e.subtitle || ''}
                                    placeholder="Subtítulo (ex: Kuduro)"
                                    onChange={(ev) => patch(i, 'subtitle', ev.target.value)}
                                    disabled={e.auto_subtitle}
                                    title={e.auto_subtitle ? 'Automático: é o género escolhido pelo sistema' : undefined}
                                    style={e.auto_subtitle ? { ...inputStyle, backgroundColor: '#f5f5f5', color: '#888' } : inputStyle}
                                />
                            </div>
                            {!e.eligible && (
                                <div style={{
                                    marginTop: 8, padding: '6px 10px', borderRadius: 6,
                                    backgroundColor: '#fff8e1', border: '1px solid #ffe082',
                                    fontSize: 12, color: '#b26a00',
                                    display: 'flex', alignItems: 'center', gap: 6,
                                }}>
                                    <MdWarning size={14} />
                                    Não aparece na home:
                                    {e.verified !== 1 && ' não está verificada.'}
                                    {e.status !== 'public' && ' está privada.'}
                                    {e.track_count < 1 && ' não tem faixas.'}
                                </div>
                            )}
                        </div>

                        <button
                            onClick={() => remove(i)}
                            title="Remover da secção"
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: 34, height: 34, borderRadius: 8,
                                border: '1px solid #d32f2f', backgroundColor: '#fff',
                                color: '#d32f2f', cursor: 'pointer', flexShrink: 0,
                            }}
                        ><MdDelete size={18} /></button>
                    </div>
                ))}
            </div>

            {dirty && (
                <p style={{ marginTop: 16, fontSize: 13, color: '#b26a00' }}>
                    Tens alterações por guardar.
                </p>
            )}
        </div>
    );
}
